export default "__VITE_ASSET__CA9406kK__"